const Video = () => (
    <svg width="48" height="48" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 23.0453V9.05206C10 7.4417 11.8061 6.49166 13.1331 7.40398L23.5466 14.5633C24.7177 15.3684 24.699 17.1038 23.5109 17.8835L13.0973 24.7174C11.7673 25.5902 10 24.6361 10 23.0453Z" fill="#FFFFFF" stroke="#FFFFFF"/>
    </svg>
)

export default Video